var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"content",staticStyle:{"background-color":"#eeeeee"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }